import { APP_BEYOND_URL } from '../../tracker.constants';

const getUrl = (path, params) => {
  if (!params) {
    return path;
  }
  return `${path}?${params}`;
};

export const generateIframe = (trackingKey, path) => {
  const app = document.getElementById('root').parentElement;

  if (trackingKey) {
    const appBackground = document.querySelector('.app-background');
    if (appBackground) {
      appBackground.style.background = 'none';
    }

    const params = new URLSearchParams(window.location.search);

    const url = getUrl(path, params.toString());

    app.innerHTML = `
        <iframe 
          src="${url}" 
          style="width:100vw; height:100vh; border:0"/>
      `;
  }
};

export const handleIframeMessage = event => {
  if (event.origin === APP_BEYOND_URL) {
    const { action, url } = event.data;
    if (action === 'exitByAppLoggiIframe' && url) {
      window.location.replace(url);
    }
  }
};
